export default __webpack_public_path__ + "img/eb1f2f294a67576e59de40f6cc88c8b5.svg";